import { z } from "zod";

const hardWareInfoItemSchema = z.object({
  type: z.number(),
  hardwareID: z.number(),
});

export const iCafeDetailResponseSchema = z.object({
  companyName: z.string(),
  bizType: z.string(),
  bizRegisterDate: z.string().nullable().optional(),
  franchiseCode: z.number(),
  lineCompanyCode: z.number(),
  lineGoodsCode: z.number(),
  bizItem: z.string(),
  phoneNumber: z.string().optional(),
  personName: z.string(),
  bizOwnerRegisterNumber: z.string().optional(),
  workZipCode: z.string(),
  workBasicAddress: z.string(),
  workDetailAddress: z.string(),
  postZipCode: z.string(),
  postBasicAddress: z.string(),
  postDetailAddress: z.string(),
  mngAppCode: z.number(),
  pcCnt: z.number(),
  osCode: z.number(),
  certificateFileName: z.string(),
  managerMobilePhoneNumber: z.string().optional(),
  managerMobileMarketingPolicyAgree: z.boolean(),
  managerMobileMarketingPolicyUpdatedAt: z.string().optional(),
  hardWareInfo: z.array(hardWareInfoItemSchema),
});

export type ICafeDetailResponseType = z.infer<typeof iCafeDetailResponseSchema>;
